import { IRouterGuard } from '@/interfaces/interfaces';

export const redirectGuard = (params: IRouterGuard) => {
  const {to, from, next} = params;
  if (to.hash.startsWith('#modal') || from.hash.startsWith('#modal')) {
    return next();
  }
  return next();
};
